import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { App } from './App.jsx';
import { BranchProvider } from './context/BranchContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { ThemeProvider } from './context/ThemeContext.jsx';
import { msalInstance } from './config/msalConfig.js';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <BranchProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </BranchProvider>
          </AuthProvider>
        </QueryClientProvider>
      </MsalProvider>
    </ThemeProvider>
  </StrictMode>
);
